import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

function Header1({ title, desc }) {
    const theme = useTheme();
    return (
        <Box
            fontWeight={"bold"}
            style={{
                width: "100%",
                padding: "50px 50px 0 50px",
                color: `${theme.palette.secondary.main}`,
            }}
        >
            <Typography variant="h4" component="h3" fontWeight={"bold"}>
                {title}
            </Typography>
            <Typography fontWeight={"bold"} color={"#76232d"}> {desc}</Typography>
        </Box>
    );
}

export default Header1;
